import { Figure as IFigure } from "../interfaces/figure";

const Figure = ({figure}: {figure: IFigure}) => {
    return (
        <div id={figure.id + ''} className="p-4 figure">{figure.x} x {figure.y}</div>
    );
}

export default Figure;